module.exports = __webpack_public_path__ + "static/pressemitteilung_hb8-118a4eb643a6f8d3ac11ecb50365eeda.pdf";